export const INDETERMINATE = Symbol('INDETERMINATE');
export type IndeterminateValue = typeof INDETERMINATE;

export function isIndeterminate<T>(value: T | IndeterminateValue): value is IndeterminateValue {
  return value === INDETERMINATE;
}

export const INDETERMINATE_TEXT = 'various';
